import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import configureStore from './Store/configureStore';
import { ThemeProvider } from "styled-components";
import { StripeProvider } from 'react-stripe-elements';

import { themes } from './Constants/Themes';
import AppConsts from './Constants/AppConsts';
import App from './App';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
export const store = configureStore(initialState);
const rootElement = document.getElementById('root');

ReactDOM.render(
        <Provider store={store}>
            <Router basename={baseUrl}>
                <ThemeProvider theme={themes.usRealty}>
                    <StripeProvider apiKey={AppConsts.stripeApiKey}>
                        <App />
                    </StripeProvider>
                </ThemeProvider>
            </Router>
        </Provider>,
    rootElement);
